var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CEESAR-ModelTable',{attrs:{"title":"Trajectories","label":"Trajectory","model":"trajectory","fileRoute":"trajectories/file"}})}
var staticRenderFns = []

export { render, staticRenderFns }